import { POST } from "@/src/network/fetchers";
import { IBaseApiResponse } from "@/src/network/network.types";
import * as yup from 'yup';

/**
 * @interface
 * @extends IBaseApiResponse<{ message: string }, { details: string }>
 */
export interface IForgotPasswordReturn extends IBaseApiResponse<{ message: string }, { details: string }> {

}

/**
 * @interface
 * 
 * @member email
 */
export interface IForgotPasswordRequest {
    email: string
}

// SCHEMA
export const forgotPasswordSchema = yup.object({
    email: yup.string().typeError('Email is required').email().required('Email is required'),
})

// ROUTE
export const FORGOT_PASSWORD = '/forget-password';

/**
 * Start the password reset process. 
 * Upon posting with this route, an email will be sent to the specified user's inbox (if the user exists in the system).
 * 
 * @param request 
 * @returns 
 */
export const forgotPassword = async (request?: IForgotPasswordRequest): Promise<IForgotPasswordReturn> => {

    try {
        const res = await POST(FORGOT_PASSWORD, false, undefined, request);

        return {
            payload: res?.payload,
            success: res?.success,
            errors: res?.errors,
        }
    } catch (err) {
        return {
            payload: undefined,
            success: false,
            errors: undefined,
        }
    }
   
}
